<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part02">
<div class="partHead" id="ph02">
<a id="page113">
</a><h2 class="partNumber" style="text-indent: 0%;"><a id="page113"><span class="xrefInternal"></span></a><a href="#/text/9780062018465_Contents#part_02"><span class="bold">PART II</span></a></h2>
<h2 class="partTitle" style="text-indent: 0%;"><a href="#/text/9780062018465_Contents#part_02"><span class="bold">A T<span class="smallCaps1">HIRD</span> R<span class="smallCaps1">ENAISSANCE, BETWEEN</span> D<span class="smallCaps1">OUBT AND</span> D<span class="smallCaps1">ARWIN</span></span></a></h2></div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062018465_Part_2.vue?77afc098